import { Task } from "../types";
import {
  ADD_TO_TASKS_QUEUE,
  CHANGE_TASK_DISPLAY_STATUS,
  CHANGE_TASK_FAILURE,
  CHANGE_TASK_SUCCESS,
} from "./constants";
import { Action } from "./types";

export default function tasks(state: Task[] = [], action: Action): Task[] {
  switch (action.type) {
    case ADD_TO_TASKS_QUEUE:
      if (state.length >= 10) {
        for (let i = 0; i <= state.length - 1; i++) {
          if (state[i].status === "success") {
            state.splice(i, 1);
            break;
          }
        }
      }
      return [...state, action.payload];
    case CHANGE_TASK_SUCCESS:
      return state.map((task) =>
        task.taskId === action.payload.taskId ? { ...task, status: "success" } : task
      );
    case CHANGE_TASK_FAILURE:
      return state.map((task) =>
        task.taskId === action.payload.taskId
          ? {
              ...task,
              status: "failure",
              errorCode:
                action.payload.error.response && "status" in action.payload.error.response
                  ? action.payload.error.response.status
                  : null,
              errorText:
                action.payload.error.response && "statusText" in action.payload.error.response
                  ? action.payload.error.response.statusText
                  : action.payload.error.message,
              errorData:
                action.payload.error.response && "data" in action.payload.error.response
                  ? action.payload.error.response.data
                  : null,
            }
          : task
      );
    case CHANGE_TASK_DISPLAY_STATUS:
      return state.map((task) =>
        task.taskId === action.payload.taskId ? { ...task, display: false } : task
      );
    default:
      return state;
  }
}
